import { API_BASE } from './api';
import { getToken } from './auth';

/**
 * 触发「在线独立页」导出：直接调用后端 /memorials/:id/export，
 * 后端聚合数据并生成自包含 HTML 文件流，前端接收后作为附件下载。
 *
 * 与前端 JSZip 离线归档的区别：
 *   - 本函数：后端生成，单个 .html，联网打开完整，适合转发 / 网盘 / 存档
 *   - MemorialExport：前端打包，含影像原文件的 .zip，可断网 / 刻盘查看
 */
export async function downloadOnlineExport(opts: {
  memorialId: string;
  name: string;
  unlockToken?: string;
}): Promise<void> {
  const headers: Record<string, string> = {};
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (opts.unlockToken) headers['X-Memorial-Unlock'] = opts.unlockToken;

  const res = await fetch(`${API_BASE}/memorials/${opts.memorialId}/export`, { headers });
  if (!res.ok) {
    throw new Error(`导出失败（${res.status}）`);
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${opts.name}-纪念馆.html`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
